/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import FormGroup from '@material-ui/core/FormGroup';

import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


import style from './styles.scss'
const AntSwitch = withStyles((theme) => ({
  root: {
    width: 48,
    height: 24,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 5,
    color: '#ea067e',
    '&$checked': {
      transform: 'translateX(22px)',
      color: '#ea067e',
      '& + $track': {
        opacity: 1,
        backgroundColor: '#fce6f2',
        borderColor: '#ea067e',
      },
    },
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: 'none',

  },
  track: {
    border: '1px solid #ea067e',
    borderRadius: 22,
    opacity: 1,
    backgroundColor: '#fce6f2',
  },
  checked: {},
}))(Switch);

/*
  Bold and regular text will have different widths. This will lead to ui glitches when switch state is changed.
  To fix that, the bold text is always in dom. Visibility hidden is applied to it when normal text is to be shown.
  This will make sure that the width of the grid component is always the same.
  The normal text is overlapped on top of the hidden bold text using absolute positioning.
*/

const EdwSwitchButton = (props) => {
  return (
    <div className="row" style={{ margin: 0 }}>
      <FormGroup>

        <Typography component="div">
          <Grid component="label" container alignItems="center" spacing={1}>

            <Grid item style={{ position: 'relative' }}>
              <span className={`edw-switch-active`} style={{ visibility: props.checked ? 'hidden' : '' }}>{props.leftLable}</span>
              {props.checked && <span className={'edw-widget-filter-lable'} style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -37%)',
                width: '100%',
                height: '100%'
              }}>{props.leftLable}</span>}

            </Grid>
            <Grid item>
              <AntSwitch checked={props.checked} onChange={props.handleChange} name="checkedC" />
            </Grid>
            <Grid item style={{ position: 'relative' }}>
              <span className={`edw-switch-active`} style={{ visibility: !props.checked ? 'hidden' : '' }}>{props.rightLable}</span>
              {!props.checked && <span className={'edw-widget-filter-lable'} style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -37%)',
                width: '100%',
                height: '100%'
              }}>{props.rightLable}</span>}
            </Grid>
          </Grid>
        </Typography>
      </FormGroup>
    </div>
  );
}

export default EdwSwitchButton;